export default {"src":"/_next/static/media/Incluso Services Logogram-Icon.f8bc27f5.svg","height":394,"width":394,"blurWidth":0,"blurHeight":0};